import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { UnderlinedHeader } from '@components/typographies';
import { anchors } from '@store/DevOpsData';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer className="d-flex flex-column flex-lg-row align-items-center">
				<UnderlinedHeader className="align-self-start">
					DevOps & Admins
				</UnderlinedHeader>
				<div
					className={classNames(styles.stages, 'd-flex justify-content-center')}
				>
					{anchors.map((anchor) => (
						<Link
							className="d-flex flex-column align-items-center"
							to={anchor.link}
							key={anchor.title}
						>
							<div
								className={classNames(
									styles.iconContainer,
									'd-flex justify-content-center align-items-center'
								)}
							>
								{anchor.icon}
							</div>
							<p className="uppercase text-center">{anchor.title}</p>
						</Link>
					))}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
